module.exports = __webpack_public_path__ + "static/media/icon-eye-off-white.668fe47e.svg";